<div class="guided-tour-modal">
  <div
    [style]="dialogStyle"
    [attr.id]="targetId"
    class="guided-tour-modal--content"
  >
    <div class="guided-tour-modal--body">
      <div [style]="viewStyle" class="guided-tour-modal--static-view">
        <ng-content></ng-content>
      </div>
      <div class="guided-tour-modal--text">
        <strong>
          {{ textBaseKey + '.step' + currentStep + '.text' | transloco }}
        </strong>
      </div>
    </div>
    <div class="guided-tour-modal--footer">
      <markant-icon-button
        *ngIf="showPreviousButton"
        class="guided-tour-modal--previous-button"
        icon="m_arrow-left"
        (click)="emitPrevious()"
      ></markant-icon-button>
      <markant-icon-button
        class="guided-tour-modal--next-button"
        icon="m_arrow-right"
        (click)="emitNext()"
      ></markant-icon-button>
    </div>
  </div>
</div>
